import { render, staticRenderFns } from "./ParkingComplexCard.vue?vue&type=template&id=2dd64357"
import script from "./ParkingComplexCard.vue?vue&type=script&lang=js"
export * from "./ParkingComplexCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports